"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _common = require("@/api/common");
var _default = exports.default = {
  components: {
    CountTo: _vueCountTo.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      dashboardData: {
        anchorCountryList: [],
        onlineUserCountList: [],
        videoCountUserList: [],
        onlineAllUserList: [],
        oldCoinUserList: [],
        onlineAllUserIdsList: []
      },
      times: [],
      listQuery: {
        startTime: '',
        endTime: ''
      },
      userPayRotes: 0,
      disabled: true,
      dialogShowOnline: false
    };
  },
  computed: {
    totalNumberOfCallRate: function totalNumberOfCallRate() {
      if (this.dashboardData.totalNumberOfCallCount === 0 || this.dashboardData.totalNumberOfCallSucc === 0) return 0;
      var tempNum = this.dashboardData.totalNumberOfCallSucc / this.dashboardData.totalNumberOfCallCount;
      return isNaN(tempNum) ? 0 : tempNum * 100;
    },
    totalNumberOfAnchorCallRate: function totalNumberOfAnchorCallRate() {
      if (this.dashboardData.totalNumberOfAnchorCallCount === 0 || this.dashboardData.totalNumberOfAnchorCallSucc === 0) return 0;
      var tempNum = this.dashboardData.totalNumberOfAnchorCallSucc / this.dashboardData.totalNumberOfAnchorCallCount;
      return isNaN(tempNum) ? 0 : tempNum * 100;
    },
    totalNumberOfUserCallRate: function totalNumberOfUserCallRate() {
      if (this.dashboardData.totalNumberOfUserCallCount === 0 || this.dashboardData.totalNumberOfUserCallSucc === 0) return 0;
      var tempNum = this.dashboardData.totalNumberOfUserCallSucc / this.dashboardData.totalNumberOfUserCallCount;
      return isNaN(tempNum) ? 0 : tempNum * 100;
    },
    // 全局接通率
    totalNumberOfConnectedRate: function totalNumberOfConnectedRate() {
      if (this.dashboardData.totalNumberOfCallSucc === 0 || this.dashboardData.totalNumberOfCallSuccess === 0) return 0;
      var tempNum = this.dashboardData.totalNumberOfCallSuccess / this.dashboardData.totalNumberOfCallSucc;
      return isNaN(tempNum) ? 0 : tempNum * 100;
    },
    // 用户接通率
    totalNumberOfUserConnectedRate: function totalNumberOfUserConnectedRate() {
      if (this.dashboardData.totalNumberOfAnchorCallSucc === 0 || this.dashboardData.totalNumberOfUserCallSuccess === 0) return 0;
      var tempNum = this.dashboardData.totalNumberOfUserCallSuccess / this.dashboardData.totalNumberOfAnchorCallSucc;
      return isNaN(tempNum) ? 0 : tempNum * 100;
    },
    // 主播接通率
    totalNumberOfAnchorConnectedRate: function totalNumberOfAnchorConnectedRate() {
      if (this.dashboardData.totalNumberOfUserCallSucc === 0 || this.dashboardData.totalNumberOfAnchorCallSuccess === 0) return 0;
      var tempNum = this.dashboardData.totalNumberOfAnchorCallSuccess / this.dashboardData.totalNumberOfUserCallSucc;
      return isNaN(tempNum) ? 0 : tempNum * 100;
    }
  },
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$getHomeDashboa, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _common.getHomeDashboard)(this.listQuery);
            case 1:
              _yield$getHomeDashboa = _context.v;
              code = _yield$getHomeDashboa.code;
              data = _yield$getHomeDashboa.data;
              if (code === 0) {
                this.dashboardData = data;
                if (this.dashboardData.daysNewCharge === 0 || this.dashboardData.daysNew === 0) {
                  this.userPayRotes = 0;
                } else {
                  this.userPayRotes = (this.dashboardData.daysNewCharge / this.dashboardData.daysNew * 100).toFixed(2);
                }
              }
              this.disabled = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    showOnline: function showOnline() {
      this.dialogShowOnline = true;
      this.dashboardData.onlineAllUserIdsList;
    },
    handleFilter: function handleFilter() {
      this.disabled = true;
      this.init();
    }
  }
};